import { render, staticRenderFns } from "./TwoNav.vue?vue&type=template&id=3197f1be&"
import script from "./TwoNav.vue?vue&type=script&lang=js&"
export * from "./TwoNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports